import Stack from '@mui/material/Stack';
import ControlKind from '../Shared/controlKind';
import controlIcons from '../WorkflowEngine/ControlIcons';
import controlDictionary from '../Controls/controlDictionary';

export default (kind: ControlKind | undefined) => {
  const icon = controlIcons.find((i) => i.type === kind)?.icon;

  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundColor: '#5BC2E726',
        borderStyle: 'solid',
        borderColor: '#75C0E341',
        borderWidth: '6px',
        height: controlDictionary[kind as ControlKind].previewCardHeight
      }}
    >
      {icon}
    </Stack>
  );
};
